module.exports = __webpack_public_path__ + "static/media/Vanguard.fbb9a2f7.svg";